import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import {
  useDashboardContext,
} from 'Views/Dashboard/DashboardContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import ActiveScenarioChartDesktop from './ActiveScenarioChartDesktop';
import ActiveScenarioChartMobile from './ActiveScenarioChartMobile';

const ActiveScenarioChartPicker = props => {
  const { clientDashboardResource } = useDashboardContext();
  const isMobile = useMobileLayout();

  const ScenarioChartComponent = (isMobile) ? ActiveScenarioChartMobile : ActiveScenarioChartDesktop;

  return pickWithPriority(clientDashboardResource, [
    [fr.relationships.facetPlanMultiChartData.name, <ScenarioChartComponent {...props} />],
  ], null);
};

export default ActiveScenarioChartPicker;
